import React from 'react';
import { Link } from 'react-router-dom';
import yellowWoman from '../../assets/people.png';
import AIMix from '../../assets/teach2.jpg';

const ITSupport =()=>{

    return(
        <section className='container mx-auto px-4 md:px-0 font-nunito mt-16'>
             <div className="relative">
                <img src={yellowWoman} alt="Slide 3" className="w-full h-64 md:h-80 lg:h-96 object-cover" />
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <h2 className="text-white text-4xl lg:text-6xl font-bold text-center">Technology Consulting</h2>
                </div>
            </div>
            <div className="flex flex-col md:flex-row items-center mt-8">
                <img src={AIMix} alt="About Us" className="w-full md:w-1/2 md:mt-0 object-cover opacity-70" /> <br />
                <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                    <h1 className='font-bold text-center text-justify lg:text-4xl'>Technology Consulting</h1>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                    As a market leader in enterprise IT consulting with 2 decades of experience, IT consultant services are an integral part of consulting. The target of seeking IT consulting services is to stay updated and competitive in the marketplace as per the most recent technology trends. twenty first century businesses homeowners are typically seen checking out such services for adding worth to your business.
                    </p>
                </div>
            </div> <br /><br />
            <div className='md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify items-center'>
                <h1 className='font-bold text-center text-justify lg:text-4xl'>Our Technology Consulting Service</h1>
                <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify"> 
                    An information technology consultant servicer provides recommendation, guidelines and a road map for sourcing, 
                    utilizing and managing IT assets and resources. an IT consultant provides organizations with best practices for 
                    using IT solutions and services for your business objectives and in solving your problems. Regardless of whether 
                    you have committed IT staff, attempting to discover and execute each IT arrangement that serves your business 
                    needs can turn out to be expensive and occupy you from your center work.
                </p>
            </div> <br /><hr /><br />
            <div className="flex flex-col justify-center items-center space-y-4">
                <h1 className="font-bold text-center lg:text-4xl">
                Connect with us today for a free consultation!
                </h1>
                <div>
                <button className="rounded bg-blue-900 py-2 px-4 font-bold text-[#d4af37] transition-transform duration-300 hover:scale-110 hover:bg-[#013751]">
                      <Link to={'/ContactPage'}> Contact Us</Link> 
                    </button>
                </div>
            </div>
        </section>
    )
}
export default ITSupport;